import { render, staticRenderFns } from "./asGroup.vue?vue&type=template&id=08d63a7c&scoped=true&"
import script from "./asGroup.vue?vue&type=script&lang=ts&"
export * from "./asGroup.vue?vue&type=script&lang=ts&"
import style0 from "./asGroup.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./asGroup.vue?vue&type=style&index=1&id=08d63a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d63a7c",
  null
  
)

export default component.exports